<template>
    <div class="member-verified member-tab">
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false, changeUploadStatus()">
            <span class="title" slot="title">{{msg.error}}</span>
        </alart-msg>
        <div class="alarm" :class="{'red': verifiedState == 3}">
            <span v-if="verifiedState == 1">填寫資料必須與身份證上記載的完全相同</span>
            <span v-if="verifiedState == 2">資料未填</span>
            <span v-if="verifiedState == 3">房東認證失敗：身分證與真實姓名不符</span>
            <span v-if="verifiedState == 4">等待審核中</span>
            <span v-if="verifiedState == 5">已通過認證房東</span>
            <span v-if="verifiedState == 6">未通過審核原因：{{unpassReason}}</span>
            <span v-if="verifiedState == 7">帳號停用</span>
        </div>
        <div class="member-verified-wrap">
            <div class="member-verified-left" v-if="verifiedState == 1 || verifiedState == 2 || verifiedState == 3 || verifiedState == 6">
                <div class="detail-group">
                    <label for="">真實姓名</label>
                    <div class="input-error-group">
                        <input type="text" v-model="verified.name" placeholder="請輸入姓名">
                        <span v-show="error.nameErr" class="error">{{error.nameErr}}</span>
                    </div>
                </div>
                <div class="detail-group">
                    <label for="">出生年月日</label>
                    <date-picker v-model="verified.birthDay" :class="{'active': verified.birthDay}" placeholder="請輸入生日日期" format="YYYY-MM-DD" valueType="format"></date-picker>
                </div>
                <div class="detail-group">
                    <label for="">電子郵件</label>
                    <div class="input-error-group">
                        <input type="text" v-model="verified.email" placeholder="請輸入電子郵件">
                        <span v-show="error.emailErr" class="error">{{error.emailErr}}</span>
                    </div>
                </div>
                <div class="email-description">
                    <div class="line1">
                        <img src="@/assets/img/icon/info_gray.svg" alt="">
                        飛豬平台響應支持地球環保，並配合政府節能減碳計畫推
                    </div>
                    <div class="line2">
                        動，將以 E-MAIL 方式將電子發票寄送至您的電子郵件信箱，請確保E-MAIL 填寫正確。
                    </div>
                </div>
                <!-- <div class="detail-group">
                    <label for="">國籍</label>
                    <rent-select refName="withdraw" selectMsg="選擇國籍" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li data-id="0">成功</li>
                            <li data-id="1">失敗</li>
                            <li data-id="2">等待中</li>
                        </ul>
                    </rent-select>
                </div> -->
            </div>
            <div class="member-verified-right" v-if="verifiedState == 1 || verifiedState == 2 || verifiedState == 3 || verifiedState == 6">
                <!-- <div class="detail-group">
                    <label for="">發證日期</label>
                    <date-picker v-model="verified.issueDate" :class="{'active': verified.issueDate}" placeholder="2020.05.06" format="YYYY.MM.DD"   ></date-picker>
                </div>
                <div class="detail-group">
                    <label for="">發證地點</label>
                    <rent-select refName="withdraw" selectMsg="選擇發證地點" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li data-id="0">成功</li>
                            <li data-id="1">失敗</li>
                            <li data-id="2">等待中</li>
                        </ul>
                    </rent-select>
                </div>
                <div class="detail-group">
                    <label for="">領補換類別</label>
                    <rent-select refName="withdraw" selectMsg="選擇類別" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li data-id="0">成功</li>
                            <li data-id="1">失敗</li>
                            <li data-id="2">等待中</li>
                        </ul>
                    </rent-select>
                </div> -->
                <div class="detail-group">
                    <label for="">身分證字號</label>
                    <div class="input-error-group">
                        <input type="text" v-model="verified.idNumber" placeholder="請輸入身分證字號">
                        <span v-show="error.idErr" class="error">{{error.idErr}}</span>
                    </div>
                </div>
                <div class="upload-id">
                    <label for="">上傳身分證圖片(正反)</label>
                    <div class="upload-id-wrap">
                        <div  v-if="verified.identification.font.length > 0"  class="list-upload font-side">
                            <img  class="cancel" @click.prevent="verified.identification.font = []" src="@/assets/img/icon/cancel_black.svg" alt="">
                            <div  class="preview">
                                <img :src="verified.identification.font[0].blob" />
                            </div>
                        </div>
                        <div  v-else-if="verified.identification.font.length == 0 && uploadedIdentification.font && verifiedState == 6 || verifiedState == 3"  class="list-upload font-side">
                            <img  class="cancel" @click.prevent="uploadedIdentification.font = null" src="@/assets/img/icon/cancel_black.svg" alt="">
                            <div  class="preview">
                                <img :src="uploadedIdentification.font" />
                            </div>
                        </div>
                        <div v-else class="list-upload font-side">
                            <file-upload
                            v-if="verified.identification.font.length == 0"
                            class="upload-btn"
                            post-action="/upload/post"
                            input-id="font"
                            :size="1024 * 5"
                            :maximum="1"
                            :multiple="true"
                            v-model="verified.identification.font"
                            @input-filter="inputFilter"
                            ref="font">
                            <img v-if="verified.identification.font.length == 0" class="upload-icon" src="@/assets/img/icon/upload_small.svg" alt="">
                            正面
                            </file-upload>
                        </div>
                        <div v-if="verified.identification.back.length > 0" class="list-upload back-side">
                            <img class="cancel" @click.prevent="verified.identification.back = []" src="@/assets/img/icon/cancel_black.svg" alt="">
                            <div class="preview">
                                <img  :src="verified.identification.back[0].blob" />
                            </div>
                            <img v-if="verified.identification.back.length == 0" class="upload-icon" src="@/assets/img/icon/upload_small.svg" alt="">
                        </div>
                        <div  v-else-if="verified.identification.back.length == 0 && uploadedIdentification.back && verifiedState == 6 || verifiedState == 3"  class="list-upload back-side">
                            <img  class="cancel" @click.prevent="uploadedIdentification.back = null" src="@/assets/img/icon/cancel_black.svg" alt="">
                            <div  class="preview">
                                <img :src="uploadedIdentification.back" />
                            </div>
                        </div>
                        <div v-else class="list-upload back-side">
                            <file-upload
                            v-if="verified.identification.back.length == 0"
                            class="upload-btn"
                            post-action="/upload/post"
                            input-id="back"
                            :size="1024 * 5"
                            :maximum="1"
                            :multiple="true"
                            v-model="verified.identification.back"
                            @input-filter="inputFilter"
                            ref="back">
                                <img v-if="verified.identification.back.length == 0" class="upload-icon" src="@/assets/img/icon/upload_small.svg" alt="">
                                反面
                            </file-upload>
                        </div>
                    </div>
                </div>
                <button class="default-button verified" @click="saveUserIdCard" :disabled="isDone == false">認證房東</button>
            </div>
            <div class="member-verified-info" v-if="verifiedState == 4 || verifiedState == 5 || verifiedState == 7">
                <div class="list">
                    <span class="title">出租人姓名</span>
                    <span class="info">：{{verifiedInfo.name}}</span>
                </div>
                <div class="list">
                    <span class="title">出生年月日</span>
                    <span class="info">：{{verifiedInfo.birthday}}</span>
                </div>
                <div class="list">
                    <span class="title">電話號碼</span>
                    <span class="info">：{{userAccount}}</span>
                </div>
                <div class="list">
                    <span class="title">身分證字號</span>
                    <span class="info">：{{verifiedInfo.idNumber.substring(0,1)}}*********</span>
                </div>
                <div class="list" v-if="verifiedState == 5">
                    <span class="title">認證時間</span>
                    <span class="info">：{{getFormatDate(verifiedInfo.auditTime)}}</span>
                </div>
                <!-- <div class="list">
                    <span class="title">國籍</span>
                    <span class="info">{{verifiedInfo.country}}</span>
                </div> -->
                <!-- <div class="list">
                    <span class="title">發證地點</span>
                    <span class="info">{{verifiedInfo.issueLocation}}</span>
                </div>
                <div class="list">
                    <span class="title">發證日期</span>
                    <span class="info">{{verifiedInfo.issueDate}}</span>
                </div>
                <div class="list">
                    <span class="title">領補換類別</span>
                    <span class="info">{{verifiedInfo.reissueType}}</span>
                </div> -->
            </div>
        </div>
        
    </div>
</template>
<script>
import RentSelect from '@/components/widge/RentSelect.vue';
import DatePicker from 'vue2-datepicker';
import FileUpload from 'vue-upload-component';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import { mapGetters } from 'vuex'
import { 
    apiSetUserInfo,
    apiSetUserIdCard
} from "@/apis/api.js"; 
export default {
    data () {
        return {
            isDefault: false,
            isDone: false,
            testId: null,
            componentsKey: 0,
            // verifiedState: this.userStatus,
            uploadedIdentification:{
                font: null,
                back: null
            },
            verified: {
                name: null,
                email: null,
                idNumber: null,
                birthDay: null,
                identification: {
                    font: [],
                    back: []
                },
                // country: null,
                // issueDate: null,
                // issueLocation: null,
                // reissueType: null
            },
            
            // verifiedInfo: {
            //     name: '王傑西',
            //     email: 'jessie@gmail.com',
            //     idNumber: 'A*********',
            //     birthDay: '1900.07.25',
            //     country: '台灣',
            //     issueDate: '***.**.**',
            //     issueLocation: '台北',
            //     reissueType: '補發'
            // },
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                error: null,
            },
            error: {
                nameErr: '',
                emailErr: '',
                idErr: '',
            }
        }
    },
    watch: {
        verified: {
            handler: function (val) {
                // console.log(val)
                // console.log(this.getFormatDate(val.birthDay))
                if(val.idNumber){
                    val.idNumber = val.idNumber.toUpperCase()
                }
                if(val.email){
                    this.checkEmail()
                }
                if(val.name && val.email && val.idNumber && val.birthDay && val.identification.font.length > 0 && val.identification.back.length > 0){
                    this.isDone = true
                }
            },
            deep: true
        },
        verifiedInfo: {
            handler: function (val) {
                if(val.email){
                    this.verified.email = val.email
                }
                if(val.name){
                    this.verified.name = val.name
                }
                if(val.birthday){
                    this.verified.birthDay = val.birthday
                }
                if(val.idNumber){
                    this.verified.idNumber = val.idNumber
                }
            },
            deep: true,
            // immediate: true
        },
        verifiedState: {
            handler: function (val) {
                // console.log(val)
                if( val == 3 || val == 6){
                    this.$store.dispatch('getUserIdCard', 'FIRST_ID_CARD_FRONT')
                    .then( (res) => {
                        this.componentsKey += 1
                        this.uploadedIdentification.font = window.URL.createObjectURL(new Blob([res.data], { type: 'image/jpeg' }));
                    })
                    this.$store.dispatch('getUserIdCard', 'FIRST_ID_CARD_BACK')
                    .then( (res) => {
                        this.componentsKey += 1
                        this.uploadedIdentification.back = window.URL.createObjectURL(new Blob([res.data], { type: 'image/jpeg' }));
                    })
                }
            },
            immediate: true
        },
        uploadedIdentification: {
            handler: function (val) {
                // console.log(val)
                if(val.font && val.back && this.verifiedState == 6 || this.verifiedState == 3){
                    this.isDone = true
                }else{
                    this.isDone = false
                }
            },
            deep: true,
            immediate: true
        }
        
    },
    methods: {
        getSelectId: function (value) {
            this.isDefault = false
            if( value.ref == 'bank' ){
                this.bankCardState = value.id
            }else if( value.ref == 'withdraw' ){
                this.withdrawState = value.id
            }else if( value.ref == 'bankCard' ){
                this.bankCardState = value.id
            }
        },
        inputFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                // console.log('response', newFile.response)
                if (newFile.xhr) {
                //  Get the response status code
                // console.log('status', newFile.xhr.status)
                }
            }
        },
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
                    this.alart.fail = true
                    this.msg.error = '請上傳JPG或PNG檔案'
                    return prevent()
                }
                if(newFile.size > (1024*1024*5)){
                    this.alart.fail = true
                    this.msg.error = '檔案最大限制5MB'
                    return prevent()
                }
            }
            // console.log(newFile)
            // Create a blob field
            newFile.hid = this.houseIndex
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        checkUserInfo: function () {
            if(!this.verified.name){
                this.error.nameErr = '請填寫姓名'
            }else{
                this.error.nameErr = ''
            }

            this.checkEmail()

            if(!this.verified.idNumber){
                this.error.idErr = '請填寫身分證字號'
            }else{
                this.error.idErr = ''
            }

            
            if(
                this.verified.birthDay &&
                this.error.emailErr == '' &&
                this.error.nameErr == '' &&
                this.error.idErr == ''
            ){
                return true
            }else{
                return false
            }
        },
        checkEmail: function () {
            var isMail = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
            if (!isMail.test(this.verified.email)) {
                this.error.emailErr = '信箱格式錯誤';
            }else {
                this.error.emailErr = '';
            }
            if( this.verified.email == ''){
                this.error.emailErr = '請填寫信箱';
            }
        },
        saveUserInfo: function (){
            this.$analytics.logEvent('送出認證房東', { screen_name: '送出認證房東'})
            let data = {
                name: this.verified.name,
                email: this.verified.email,
                idNumber: this.verified.idNumber,
                birthday: this.verified.birthDay,
                channel: 'WEB_LANDLORD'
            }
            apiSetUserInfo(data)
            .then(res => {
                console.log(res)
                if(res.data.status == 'SUCCESS'){
                    this.$store.dispatch('getUserStatus');
                }else{
                    if(res.data.errorCode == 221006){
                        this.error.idErr = res.data.errorMsg
                    }else if(res.data.errorCode == 221005){
                        this.error.idErr = res.data.errorMsg
                    }else if(res.data.errorCode == 221028){
                        this.error.idErr = res.data.errorMsg
                    }
                }
            })
            .catch(err =>{
                console.log(err)
            })
        },
        saveUserIdCard: function (){
            if(this.verified.identification.font.length == 0 && this.verified.identification.back.length == 0 && this.uploadedIdentification.font && this.uploadedIdentification.back && this.verifiedState == 6 ||this. verifiedState == 3){
                if(this.checkUserInfo()){
                    this.saveUserInfo()
                }
            }else{
                let formData = new FormData();

                formData.append('frontSide', this.verified.identification.font[0].file);
                formData.append('backSide', this.verified.identification.back[0].file);
                if(this.checkUserInfo()){
                    apiSetUserIdCard(formData)
                    .then(res => {
                        // console.log(res)
                        if( res.data.status == "SUCCESS" ){
                            // console.log('success')
                            this.saveUserInfo()
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
                }
            }
            
        },
        getFormatDate: function (time){
            console.log(time)
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
    },
    computed: {
        ...mapGetters({
            verifiedState: 'GET_USER_STATUS',
            verifiedInfo: 'GET_USER_INFO',
            unpassReason: 'GET_USER_UNPASS_REASON',
            userAccount: 'GET_VERIFIED_USER_ACCOUNT'
        })
    },
    components:{
        RentSelect,
        DatePicker,
        FileUpload,
        AlartMsg
    }
}
</script>
<style lang="scss" scoped>
    .member-verified{
        position: relative;
        .member-verified-wrap{
            position: relative;
            padding: 0 30px;
            padding-top: 30px;
            display: flex;
            span.error{
                right: 0;
                top: -27px;
                left: unset;
                bottom: unset;
            }
            label{
                display: block;
                margin-bottom: 12px;
                font-weight: 500;
            }
            .detail-group{
                margin-bottom: 30px;
                input,
                .rent-select{
                    width: 354px;
                }
                .mx-datepicker{
                    width: 384px;
                    input{
                        width: 100%;
                        height: 44px;
                        border-radius: 4px;
                        border: solid 1px #e0dfde;
                        color: #a8a5a4;
                        padding: 13px 16px;
                        box-shadow: none;
                        margin-bottom: 0px;
                    }
                    .mx-icon-calendar,
                    .mx-icon-clear{
                        right: 14px;
                    }
                }
                .mx-datepicker:hover,
                .mx-datepicker.active{
                    input{
                        border: 1px solid #676362 !important;
                        color: #676362 !important;
                    }
                    i{
                        color: #676362;
                    }
                }
            }
            .member-verified-left{
                margin-right: 60px;
                .email-description{
                    width: 384px;
                    margin-top: -23px;
                    margin-bottom: 177px;
                    color: #676362;
                    line-height: 1.5;
                    .line1{
                        display: flex;
                        align-items: center;
                        img{
                            margin-right: 2px;
                        }
                    }
                }
            }
            .member-verified-right{
                .upload-id{
                    .upload-id-wrap{
                        display: flex;
                        .list-upload{
                            position: relative;
                            width: 148px;
                            height: 111px;
                            margin-right: 12px;
                            border-radius: 4px;
                            border: dashed 1px #cacfcd;
                            background-color: #ffffff;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            .upload-icon{
                                width: 24px;
                                height: 24px;
                                margin-bottom: 4px;
                            }
                            .cancel{
                                position: absolute;
                                cursor: pointer;
                                top: -14px;
                                right: -14px;
                            }
                            .preview{
                                width: 148px;
                                height: 111px;
                                display: flex;
                                align-items: center;
                                border-radius: 4px;
                                overflow: hidden;
                                >img{
                                    width: 100%;
                                }
                            }
                            .file-uploads{
                                width: 100%;
                                height: 100%;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                            }
                        }
                    }
                    
                }
                .verified{
                    width: 384px;
                    height: 44px;
                    margin-top: 27px;
                }
            }
            .member-verified-info{
                height: 490px;
                .list{
                    display: flex;
                    margin-bottom: 20px;
                    .title{
                        display: block;
                        width: 70px;
                        // color: #a8a5a4;
                        margin-right: 8px;
                    }
                }
            }
            
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/memberCenter/MemberVerified.vue